import React, { useState } from "react";
import { Link } from "gatsby";
import clsx from 'clsx';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles, fade, makeStyles } from '@material-ui/core/styles';
import { GiHamburgerMenu } from "react-icons/gi";
import { SiAboutDotMe } from "react-icons/si";
import { GrProjects, GrResume, GrArticle } from "react-icons/gr";
import { BiMessageAdd } from "react-icons/bi";

import '../styles/navigation.css';


const useStyles = makeStyles(() => ({
	list: {
		width: 250
	},
	fullList: {
		width: 'auto',
	}
}));

const ListMenu = (anchor, toggleDrawer, displayIcon) => {
	const classes = useStyles();

	return (
		<div
			className={clsx(classes.list, {
				[classes.fullList]: anchor === 'top' || anchor === 'bottom',
			})}
			role="presentation"
			onClick={toggleDrawer(anchor, false)}
			onKeyDown={toggleDrawer(anchor, false)}
		>
			<List>
				{[{
					name: 'ABOUT',
					url: '/',
				},
				{
					name: 'PROJECTS',
					url: '/projects'
				},
				{
					name: 'CV',
					url: '/cv'
				}].map((item, index) => (
					<ListItem button key={item.name}>
						<Link
							to={item.url}
							className="nav-link mb"
							activeClassName="active"
							style={{display:'flex'}}
						>
							<ListItemIcon>{displayIcon(item.name)}</ListItemIcon>
							<ListItemText primary={item.name} />
						</Link>
					</ListItem>
				))}
			</List>
			<Divider />
			<List>
				{[{
					name: 'CONTACT',
					url: '/contact'
				},
				{
					name: 'BLOGS',
					url: '/blogs'
				}].map((item, index) => (
					<ListItem button key={item.name}>
						<Link
							to={item.url}
							className="nav-link mb"
							activeClassName="active"
						>
							<ListItemIcon>{displayIcon(item.name)}</ListItemIcon>
							<ListItemText primary={item.name} />
						</Link>
					</ListItem>
				))}
			</List>
		</div>
	);
}

const displayIcon = (name) => {
	switch (name) {
		case 'ABOUT':
			return (
				<SiAboutDotMe style={{
					fontSize: '1.2rem'
				}} />
			);
		case 'PROJECTS':
			return (
				<GrProjects style={{
					fontSize: '1.2rem'
				}} />
			);
		case 'CV':
			return (
				<GrResume style={{
					fontSize: '1.2rem'
				}} />
			);
		case 'CONTACT':
			return (
				<BiMessageAdd style={{
					fontSize: '1.2rem'
				}} />
			);
		case 'BLOGS':
			return (
				<GrArticle style={{
					fontSize: '1.2rem'
				}} />
			);
		default:
			return;
	}
}

const NavBar = () => {
	const [display, setDisplay] = useState(false);
	const [state, setState] = React.useState({
		top: false,
		left: false,
		bottom: false,
		right: false,
	});

	const toggleDrawer = (anchor, open) => (event) => {
		if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
			return;
		}

		setState({ ...state, [anchor]: open });
	}

	return (
		<div
			className="navigation-bar"
		>
			<Link activeClassName="active" className="nav-link nav-page" to="/">ABOUT</Link>
			<Link activeClassName="active" className="nav-link nav-page" to="/projects">PROJECTS</Link>
			<Link activeClassName="active" className="nav-link nav-page" to="/blogs">BLOGS</Link>
			<Link activeClassName="active" className="nav-link nav-page" to="/cv">CV</Link>
			<Link activeClassName="active" className="nav-link nav-page" to="/contact">CONTACT</Link>
			<div className="mb-menu-hamburger">
				<GiHamburgerMenu
					onClick={toggleDrawer('top', true)}
					className="hamburger-menu"
					style={{
						fontSize: '2rem',
						color: '#666'
					}}
				/>
				<Drawer
					anchor={'top'}
					open={state['top']}
					onClose={toggleDrawer('top', false)}
				>
					{ListMenu('top', toggleDrawer, displayIcon)}
				</Drawer>
			</div>
		</div>
	)
}

export default NavBar;